
import { View } from '@/layouts/views/View'
import { Controls } from '@/ui/Preshake/Controls'
import { useState } from 'react'

export default function Preview() {
  const [selectedSpice, setSelectedSpice] = useState<number | null>(null)

  return (
        <View className="bg-blue-50 p-4">
          <Controls selectedSpice={selectedSpice} onShake={() => {}} />
          </View>
  )
}
